// require('es6-promise').polyfill()
require('es6-promise/auto');
const distance = require('fast-haversine');
var allSpots = require('./data.json');

import Vue from 'vue/dist/vue.common.js'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import VueResource from 'vue-resource'

Vue.config.productionTip = false
Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(VueResource)

import home from './components/home.vue'
import menu from './components/menu.vue'
import contact from './components/contact.vue'
import notFound from './components/notfound.vue'
import mapAndDetails from './components/mapAndDetails.vue'
import az from './components/az.vue'
import slugPage from './components/slugPage.vue'

var routes = [
  { path: '/', component: home },
  { path: '/contact/', component: contact },
  { path: '/a-z/', component: az },
  { name: 'az', path: '/a-z/:country//', component: az },
  { name: 'slug', path: '/swimspot/:slug//', component: slugPage },
  { path: '*', component: notFound },
  { path: '/404/', component: notFound },
]

var router = new VueRouter({
  // mode: 'history',
  base: '/',
  routes: routes
})

router.afterEach(function (transition) {
  if (window.ga) {
    window.ga('send', 'pageview', transition.path)
  }
});

var eventBus = window.eventBus = new Vue({});

var App = window.App = new Vue({
  router: router,
  data: {
      map: '',
      place: '',
      swimSlug: {},
  },
  mounted: function () {
    var vm = this
    eventBus.$on('slugPageEvent',(slug) => {
      var spot = vm.getSpotBySlug(slug)
      if (spot) {
        vm.swimSlug = spot
      } else {
        vm.$router.replace('/404/')
      }
    })
    eventBus.$on('redoMapEvent',() => {
      vm.mapCallback()
    })
    vm.$nextTick(function() {
      eventBus.$emit('rootReady', {})
    })
  },
  methods: {
    mapCallback: function() {
      var vm = this
      var zoom = vm.zoomLevel()
      var center = {lat: 0, lng: 0}

      if (typeof vm.$route.params.slug !== 'undefined') {
          if (vm.swimSlug !== undefined && Object.keys(vm.swimSlug).length !== 0) {
              // Individual beach page...
              zoom = 14
              center = {lat: vm.swimSlug.lat, lng: vm.swimSlug.lon}
          }
      }

      vm.map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: zoom,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.BOTTOM_CENTER
        }
      })

      if (typeof vm.$route.params.slug !== 'undefined') {
          if (vm.swimSlug !== undefined && Object.keys(vm.swimSlug).length !== 0) {
              // wait unit map is intialised then tell search
              eventBus.$emit('slugSearchEvent', vm.swimSlug)
          }
      }

      var input = document.getElementById('search')
      var autocomplete = new google.maps.places.Autocomplete(input)
      autocomplete.bindTo('bounds', this.map)
      autocomplete.addListener('place_changed', function() {
          var place = autocomplete.getPlace();
          if (!place.geometry) {
              window.alert("Please select location from the dropdown")
              return
          } else {
            vm.place = place
          }
      })
    },
    getSpotBySlug: function(slug) {
      for (var i=0; i<allSpots.length; i++) {
        if (this.slugify(allSpots[i].Name) == slug) {
          delete allSpots[i].distance
          // add images
          this.getImgsForSpot(allSpots[i], slug)
          return allSpots[i]
        }
      }
    },
    getMetaForSpot: function(thumb, imgsAry) {
      var vm = this
      vm.$http.head(thumb).then((response) => {
        imgsAry.push(
          {
            "contextLink": response.headers["map"]["x-amz-meta-contextlink"][0],
            "thumb": thumb,
            "title": response.headers["map"]["x-amz-meta-title"][0]
          }
        )
      }, (response) => {
        console.log('Meta error')
      })
    },
    getImgsForSpot: function(spotObj, slug) {
      var vm = this
      var base_url = "https://www.go-swim-outside.party/"
      var url = "https://s3-eu-west-1.amazonaws.com/www.go-swim-outside.party/?list-type=2&prefix=images/" + slug
      var imgsReturned = []
      vm.$http.get(url).then((response) => {
          var xmlDoc
          if (window.DOMParser) {
            var parser = new DOMParser();
            xmlDoc = parser.parseFromString(response.body, "text/xml");
          }
          else {
            xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.loadXML(response.body);
          }
          // miss first one as it's just the directory itself
          for (var i=1; i<xmlDoc.getElementsByTagName("Contents").length; i++) {
            // we have the key, now need to ping back s3 to get the metadata..
            var thumb = encodeURIComponent(xmlDoc.getElementsByTagName("Contents")[i].childNodes[0].textContent)
            vm.getMetaForSpot(base_url + thumb, imgsReturned)
          }
          spotObj.images = imgsReturned
      }, (response) => {
          console.log('List objects error')
      })
    },
    getNearestSpots: function(point) {
      var from = { lat: point['latitude'], lon: point['longitude'] };

      // first go thru and set distance
      for (var i=0; i<allSpots.length; i++) {
        allSpots[i].distance = (distance(from, allSpots[i]) / 1000).toFixed(2)
      }
      // now sort by distance
      allSpots.sort(function(a, b) {
        return a.distance - b.distance;
      });
      return allSpots.slice(0, 9)
    },
    slugify: function(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        //.replace(/[^\w\-]+/g, '')  // this remove accents so gone for the blacklist approach below
        .replace(/['`´’~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
    },
    getCountryAZ: function(country) {
      // go through data and build a-z in this format
      // vm.countryAZ = {
      //   'locality1': [{'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}],
      //   'locality2': [{'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}],
      //   'locality3': [{'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}, {'name': 'name1', 'slug': 'name1'}],
      // }
      var countryAZ = {}
      for (var i=0; i<allSpots.length; i++) {
        // console.log('"'+this.slugify(allSpots[i].Name)+'",')
        if (allSpots[i].Country == country.toUpperCase()) {
          var item = {'name': allSpots[i].Name, 'slug': this.slugify(allSpots[i].Name)}
          // if locality already exists append
          if (allSpots[i].Locality in countryAZ) {
            countryAZ[allSpots[i].Locality].push(item)
          // else create locality and append
          } else {
            countryAZ[allSpots[i].Locality] = [item]
          }
        }
      }
      return countryAZ
    },
    zoomLevel: function() {
      var height = document.getElementById('map').offsetHeight
      if (height > 500) {
        return 2
      }
      return 1
    },
    showLoading: function() {
      var loading = document.createElement('DIV')
      loading.className = "loading-bar"
      loading.id = "loading"
      document.body.appendChild(loading)
    },
    hideLoading: function() {
      var loading = document.getElementById('loading')
      document.body.removeChild(loading)
    }
  },
  components: {
    'mobile-menu': menu,
    'home': home,
    'mapAndDetails': mapAndDetails,
    'contact': contact,
  }
}).$mount('#app')
